import _ from 'lodash'
import apis from '@/apis'
import apisFile from '@/apis/file'
import Constants, { SECRET_KEY } from '@/constants'
import RequestUtil from '@/util/request'
import StringUtil from '@/util/string'
import bcrypt from 'bcryptjs'

const JobStatus = {
  DRAFT: 0,
  OPEN: 1,
  ON_HOLD: 2,
  FILLED: 3,
  CANCELED: 4,
}

const getPublicToken = async () => {
  const clientKey = StringUtil.getHash()
  const secretKey = `${SECRET_KEY}${clientKey}`
  const salt = await bcrypt.genSalt(10)
  const hashedKey = await bcrypt.hash(secretKey, salt)
  const token = `${clientKey}|${hashedKey}`
  // console.log('-- info', {
  //   salt,
  //   clientKey,
  //   hashedKey,
  //   secretKey,
  //   token,
  //   isVerifyCompare: await bcrypt.compare(secretKey, hashedKey),
  // })
  return token
}

export default {
  JobStatus,

  async getJobs (filters = {}) {
    let params = {
      page: 1,
      size: 999,
      direction: 'desc',
      sort: RequestUtil.snakeCase('createdAt'),
      // status: JobStatus.OPEN,
      ...filters,
    }
    params = RequestUtil.snakize(params)
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    let response = await apis.get(`${Constants.BASE_API_AIMS}public/opening`, params, headers)
    response = RequestUtil.camelize(response)
    return response
  },

  async getJob (jobId) {
    // params = RequestUtil.snakize(params)
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    let response = await apis.get(`${Constants.BASE_API_AIMS}public/opening/${jobId}`, {}, headers)
    response = RequestUtil.camelize(response)
    return response
  },

  async getNominalData (type, filters = {}) {
    let inFilters = _.omitBy(filters, (item) => item === '' || item == null)
    inFilters = RequestUtil.snakize(inFilters)
    const params = {
      ...inFilters,
    }
    // type:
    // - states
    //   - param: division_id
    //   - param: country_id
    // - coordinators
    // - contracts
    // - current_contract
    // - certificates
    // - document_types
    // - grades
    // - event_types
    // - frequency_values
    //   - param: frequency_value (string: monthly, semesterly, quarterly)
    // - shipping_companies
    //
    // # job openings
    // - certificates
    // - employment_types
    // - position_types
    // - experience_levels
    //
    // # applicants
    // - reference_questions
    //
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    const response = await apis.get(`${Constants.BASE_API_AIMS}nominal/${type}`, params, headers)
    if (response.status !== 'success') {
      throw new Error('Invalid response')
    }
    if (response.data == null) {
      throw new Error('Invalid data')
    }
    response.data = RequestUtil.camelize(response.data)
    return response
  },

  async upload (file, data = {}) {
    const indata = {
      ...RequestUtil.snakize(data),
    }
    let formData = new FormData()
    formData.append('file', file && file.raw)
    // let uploadData: Record<string, any> = await ApiFile.upload(source, undefined, formData, { // always create
    //   id,
    //   type: attr.type || DataConstants.UploadFileType.UNKNOWN,
    //   fileindex: 0,
    //   fileName: file.name,
    // })
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    const response = await apisFile.upload(`public/upload`, formData, indata, undefined, headers)
    if (response.status !== 'success') {
      throw new Error('Invalid response')
    }
    // if (response.data == null) {
    //   throw new Error('Invalid data')
    // }
    return response
  },

  async createApplicant (openingId, data = {}) {
    const params = {
      ...RequestUtil.snakize({
        openingId,
      }),
      ...RequestUtil.snakize(data),
    }
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    const response = await apis.post(`${Constants.BASE_API_AIMS}public/applicant`, params, headers)
    // Create
    // Endpoint: applicant
    // Method: POST
    // Param:
    // - opening_id (int)
    // - first (string)
    // - last (string)
    // - email (string)
    // - phone (string)
    // - address (string)
    // - city (string)
    // - state_id (int)
    // - zip (string)
    // - country_id (int)
    // - date_available (string)
    // - desired_pay (float)
    // - status (int)
    // - assigned_id (int)
    // - references (array of object)
    //    - name (string)
    //    - relationship (string)
    //    - phone (string)
    //    - email (string)
    //    - notes (string)
    //
    // Edit
    // Endpoint: applicant/{applicant_id}
    // Method: POST
    // Param:
    // - opening_id (int)
    // - first (string)
    // - last (string)
    // - email (string)
    // - phone (string)
    // - address (string)
    // - city (string)
    // - state_id (int)
    // - zip (string)
    // - country_id (int)
    // - date_available (string)
    // - desired_pay (float)
    // - status (int)
    // - assigned_id (int)
    // - references (array of object)
    //    - name (string)
    //    - relationship (string)
    //    - phone (string)
    //    - email (string)
    //    - notes (string)

    if (response.status !== 'success') {
      throw new Error('Invalid response')
    }
    if (response.data == null) {
      throw new Error('Invalid data')
    }
    return response
  },

  async attachApplicantDocument (applicantId, data) {
    let params = {
      applicantId,
      ...data,
    }
    params = RequestUtil.snakize(params)
    // Upload document
    // Endpoint: applicant/document
    // Method: POST
    // - applicant_id (int)
    // - type (string)
    // - names (array of object)
    //    - file_name
    //    - name
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    const response = await apis.post(`${Constants.BASE_API_AIMS}public/applicant/document`, params, headers)
    if (response.status !== 'success') {
      throw new Error('Invalid response')
    }
    if (response.data == null) {
      throw new Error('Invalid data')
    }
    response.data = RequestUtil.camelize(response.data)
    return response
  },

  async getReference (referenceToken) {
    // params = RequestUtil.snakize(params)
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    let response = await apis.get(`${Constants.BASE_API_AIMS}public/applicant/reference/${referenceToken}`, {}, headers)
    response = RequestUtil.camelize(response)
    return response
  },

  async createReference (referenceToken, data = {}) {
    const params = {
      ...RequestUtil.snakize(data),
    }
    let token = await getPublicToken()
    let headers = { Authorization: `Bearer ${token}` }
    // Submit Reference Form
    // Endpoint: applicant/reference/{applicant_reference_id}
    // Method: POST
    // Param:
    // - questions (array of object)
    //    - question_number (string)
    //    - answer (int)
    const response = await apis.post(`${Constants.BASE_API_AIMS}public/applicant/reference/${referenceToken}`, params, headers)
    if (response.status !== 'success') {
      throw new Error('Invalid response')
    }
    // if (response.data == null) {
    //   throw new Error('Invalid data')
    // }
    return response
  },
}
